import React from 'react';

/* Images */
import letOpGeldLenenKostGeld from '~/../img/let-op-geld-lenen-kost-geld.svg';

export default function ConversionBannerFinance() {
    return (
        <div className="let-op-geld-lenen-kost-geld">
            <img
                className="let-op-geld-lenen-kost-geld__img img-fluid"
                src={letOpGeldLenenKostGeld}
                alt="Let op! Geld lenen kost geld"
                width="400"
                height="30"
            />
        </div>
    );
}
